<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div
      v-else-if="
        !this.loading &&
          !this.errormessage &&
          this.patrols &&
          this.patrols.length > 0
      "
    >
      <div class="row">
        <card
          class="text-center mr-auto ml-auto"
          v-for="p in patrols"
          :key="p.Critter"
        >
          <template slot="header">
            <h4 class="card-title">
              {{ p.Critter }}
            </h4>
            <p class="card-category text-danger">
              {{ p.TroopGuideName }}
            </p>
            <hr>
          </template>
          <div class="card-body">
            <el-table
              class="table-striped"
              style="min-width:180px"
              header-row-class-name="text-primary"
              :header-cell-style="headerCellStyle"
              :cell-style="cellStyle"
              :show-header="showHeader"
              :data="p.PatrolMembers"
            >
              <el-table-column class-name="text-primary pointer">
                <template slot-scope="props">
                  <router-link
                    :to="'/staff/participant?s=' + props.row.ScouterKey + '&r=patrol-list'"
                    tag="div"
                  >
                    {{ props.row.FullName }}
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </card>
      </div>
    </div>
    <div v-else>
      There are currently no Patrols registered for this course.
    </div>
  </div>
</template>

<script>
import oops from '@/components/_main/oops.vue'
import patrolApi from '@/services/api/patrol'

export default {
  name: 'Patrols',
  components: {
    oops
  },
  data: function () {
    return {
      patrols: null,
      loading: true,
      showHeader: false,
      errormessage: null,
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      }
    }
  },
  mounted () {
    patrolApi
      .list(this.$root.courseKey)
      .then(x => {
        for (let i = 0; i < x.length; i++) {
          if (!x[i].TroopGuideName) {
            x[i].TroopGuideName = 'Not Assigned'
          }
        }
        this.patrols = x
      })
      .catch(error => {
        console.log(error)
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
